import { FC, Fragment } from "react";
import { sanitizeHtml } from "@smile2impress/attraction-utils";
import {
    Box,
    Spacer,
    Heading,
    Text,
    Button,
    Grid,
    GridItem,
    useBreakpointValue,
    Flex,
} from "@smile2impress/components/relaunch";
import { useGoToBooking } from "hooks/useGoToBooking";

import Link from "components/Link";

import { ListWithCTAProps } from "./ListWithCTA.types";
import { ListItem } from "./components";

export const ListWithCTA: FC<ListWithCTAProps> = ({ content, headingAs }) => {
    const { title, text, cta, items } = content;
    const { goToBooking } = useGoToBooking();
    if (!cta.onClick && !cta.link) {
        cta.onClick = goToBooking;
    }
    const { text: buttonText, onClick, link } = cta;

    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
        desktopXL: false,
    });

    return (
        <Box as="section">
            <Grid
                templateColumns={[
                    null,
                    null,
                    `${11 / 24}fr ${2 / 24}fr ${11 / 24}fr`,
                ]}
                templateRows={[`auto auto auto`, null, null]}
            >
                <GridItem mb={[2, 0, 0]} pl={[0, 0, 4]}>
                    <Heading
                        textStyle={["title1"]}
                        color={["text.base"]}
                        as={headingAs}
                        mb={[1]}
                    >
                        {title}
                    </Heading>
                    <Text
                        textStyle="body"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(text),
                        }}
                    />
                </GridItem>
                <Spacer />
                <GridItem pr={[0, 0, 4]}>
                    <Flex
                        direction={["column"]}
                        rowGap={[1, 1, 2]}
                        mb={[2, 2, 3]}
                    >
                        {items.map((item, index) => (
                            <Fragment key={`ListItem-${index}`}>
                                <ListItem {...item} />
                            </Fragment>
                        ))}
                    </Flex>
                    <Button
                        as={Link}
                        {...(onClick ? { onClick } : {})}
                        {...(link ? { href: link } : {})}
                        width={["100%", "100%", "auto"]}
                    >
                        {buttonText}
                    </Button>
                </GridItem>
            </Grid>
            {!isMobile && <></>}
        </Box>
    );
};
